import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {baseUrl} from '@/config/env';


export const tabulateDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "商品名称",
            prop: "productName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '品牌',
            prop: 'brandName',
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: 'SKU',
            prop: 'skuValue',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '库存',
            prop: 'stockNum',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '已售数量',
            prop: 'number',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '剩余库存',
            prop: 'remainNum',
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};